import { useEffect, useState } from 'react';

import { octokit } from './utils/octokit'

const API_ENDPOINT = "/users/abdelghanyMh/repos?type=owner&per_page=100&sort=sort&direction=desc"

const useOctokit = () => {
    const [repos, setRepos] = useState([])
    const [languages, setLanguages] = useState([])




    const updateLanguages = (totalTopics, topics) => {
        const tmp = topics.filter(topic => totalTopics.indexOf(topic) === -1)
        return [...totalTopics, ...tmp]
    }

    const formatData = (data) => {
        if (data) {
            let totalTopics = []

            const formated = data
                .filter(repo => repo.fork === false)
                .map((repo) => {

                    const { id, name, html_url, description, homepage, topics } = repo

                    totalTopics = updateLanguages(totalTopics, topics);

                    return { id, name, html_url, description, homepage, topics }

                })

            setRepos(formated)
            setLanguages(totalTopics)
        }
    }

    const fetchGithubProjects = async () => {
        try {
            await octokit.request(`GET ${API_ENDPOINT}`, {})
                .then(res => {
                    setRepos(res.data)
                    formatData(res.data)
                })

        } catch (error) {
            throw new Error(`coldn't fetch projects from github ${error}`)
        }
    }

    useEffect(() => {
        fetchGithubProjects()
        formatData()
        // eslint-disable-next-line
    }, [])

    return {
        repos,
        languages
    }
}
export default useOctokit